import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { ROUTES } from '@core';
import { Colors } from '@utils';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="193"
        height="77"
        viewBox="0 0 193 77"
        fill="none"
      >
        <path
          d="M59.9508 49.012V59.38H47.6628V75.604H35.3748V59.38H0.71875V48.052L35.1828 1.3H47.6628V49.012H59.9508ZM35.6628 15.028L11.2787 49.012H35.6628V15.028Z"
          fill={Colors.gray200}
        />
        <path
          d="M95.8563 76.948C86.1283 76.948 78.6403 73.684 73.3923 67.156C68.2083 60.564 65.6162 51.06 65.6162 38.644C65.6162 26.612 68.3683 17.172 73.8723 10.324C79.4403 3.476 86.9603 0.052002 96.4323 0.052002C105.776 0.052002 113.104 3.476 118.416 10.324C123.728 17.108 126.384 26.516 126.384 38.548C126.384 50.58 123.664 59.988 118.224 66.772C112.784 73.556 105.328 76.948 95.8563 76.948ZM95.9523 65.812C101.712 65.812 106.064 63.572 109.008 59.092C111.952 54.548 113.424 47.828 113.424 38.932C113.424 29.844 111.952 22.932 109.008 18.196C106.128 13.46 101.904 11.092 96.3363 11.092C90.5762 11.092 86.1602 13.46 83.0882 18.196C80.0163 22.932 78.4803 29.844 78.4803 38.932C78.4803 47.7 79.9522 54.388 82.8962 58.996C85.9043 63.54 90.2563 65.812 95.9523 65.812Z"
          fill={Colors.gray200}
        />
        <path
          d="M192.281 49.012V59.38H179.993V75.604H167.705V59.38H133.049V48.052L167.513 1.3H179.993V49.012H192.281ZM167.993 15.028L143.609 49.012H167.993V15.028Z"
          fill={Colors.gray200}
        />
      </svg>
      <h6 className="mt-4 text-lg font-normal text-gray-600">
        {t('general.pageNotFound')}
      </h6>
      <p className="mt-4">
        <Link to={ROUTES.main} className="btn btn-outline">
          {t('common.buttonLabel.goBack')}
        </Link>
      </p>
    </div>
  );
};

export default NotFound;
